module.exports = __webpack_public_path__ + "static/media/teamwork.d2605492.svg";